import React from "react";
import { Paper, Typography } from "@mui/material";

const panelSx = { p: 3, maxWidth: 960 };

function PlaceholderSection({ title, description }) {
  return (
    <Paper elevation={0} variant="outlined" sx={panelSx}>
      <Typography variant="h6" component="h2" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Paper>
  );
}

export function AdministrationStoragePlaceholder() {
  return (
    <PlaceholderSection
      title="Storage Management"
    />
  );
}

export function AdministrationPatrollingRouteMgmtDemo() {
  return (
    <PlaceholderSection
      title="Patrolling Route Management"
    />
  );
}

export function AdministrationIotDevicesMgmtDemo() {
  return (
    <PlaceholderSection
      title="IOT Devices Management"
      description="Configure and monitor IoT devices connected to the platform."
    />
  );
}
